export default __webpack_public_path__ + "static/media/elk.a547ac72.png";